import { StackLayout } from '@euler/app/components/StackLayout';
import { Typography } from '@euler/app/components/typography';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { QuotationConstructionItem } from '@euler/model/task-detail';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { ReadonlyMaterialItemView } from './MaterialItemView';
import { PriceInfoView } from './PriceInfoView';

export const ReadonlyQuotationSubjectConstructionItemView = memo(
  ({
    item,
    style,
  }: {
    item: QuotationConstructionItem;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();

    return (
      <StackLayout style={style}>
        <StackLayout direction="row" gap={rpx(4)} alignItems="center">
          <StackLayout flex={1} gap={rpx(4)}>
            <StackLayout direction="row" alignItems="center" gap={rpx(5)}>
              <Typography.Text flex={1} size={rpx(19)} medium>
                {item.name}
              </Typography.Text>
            </StackLayout>
            <HStack justifyContent="flex-start">
              <Typography.Text color="#777" flexShrink={0} numberOfLines={1}>
                工时费:{' '}
              </Typography.Text>
              <PriceInfoView
                price={item.price}
                discountPrice={item.discountPrice}
                discountRemark={item.discountRemark}
              />
            </HStack>
            {item.remark ? (
              <StackLayout direction="row">
                <Typography.Text color="#777" flexShrink={0} numberOfLines={1}>
                  备注:{' '}
                </Typography.Text>
                <Typography.Text>{item.remark}</Typography.Text>
              </StackLayout>
            ) : null}
          </StackLayout>
        </StackLayout>
        <StackLayout
          gap={rpx(8)}
          css={`
            margin-top: ${rpx(8)}px;
          `}
        >
          {item.materials.map(material => (
            <ReadonlyMaterialItemView material={material} key={material.id} />
          ))}
        </StackLayout>
      </StackLayout>
    );
  },
);
